// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._19pkv77o{margin-top:var(--ds-space-025,2px)}\n._1e0c1txw{display:flex}\n._2hwxv77o{margin-right:var(--ds-space-025,2px)}\n._otyrv77o{margin-bottom:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
